import { z } from 'zod'
import interceptedAxios from '../../../utils/interceptedAxios'

const ZSiteDeleteCampaignApiResponse = z.object({
  http_status: z.number(),
  data: z.optional(z.string()),
  error: z.boolean(),
  error_message: z.optional(z.string())
})

const ZSiteDeleteCampaignErrorApiResponse = z.object({
  error: z.boolean(),
  http_status: z.number(),
  error_message: z.optional(z.string())
})

export type DeviceDeleteCampaignApiResponse = z.infer<typeof ZSiteDeleteCampaignApiResponse>
export type DeviceDeleteCampaignErrorApiResponse = z.infer<typeof ZSiteDeleteCampaignErrorApiResponse>

export async function siteDeleteCampaign (
  selectedSiteId: string,
  selectedSiteName: string,
  onSuccess: (deleteStatusData: string, httpStatus: number) => any,
  onFailure: (errorMessage: string, httpStatus: number) => any
): Promise<void> {
  const url = `/assetrest/api/v2/udp/tiq/sites?siteId=${selectedSiteId}&siteName=${selectedSiteName}`
  interceptedAxios
    .delete(url, { timeout: 300000 }) // timeout after 5 minutes = 5 × 60 x 1000
    .then((response) => {
      const parseResponse = response.data
      if (parseResponse.error === false) {
        // istanbul ignore else
        if (parseResponse.data !== null && parseResponse.data !== undefined) {
          onSuccess(parseResponse.data, parseResponse.http_status)
        } else {
          onFailure(parseResponse.error, parseResponse.http_status)
        }
      } else {
        onFailure(parseResponse.error_message, parseResponse.http_status)
      }
    })
    .catch((error) => {
      if (error.response !== undefined) {
        onFailure(error.response.data?.error_message ?? 'Network Error', error.response.http_status)
      } else {
        onFailure('Network Error', 404)
      }
    })
}
